export const SET_LOADING = 'SET_LOADING';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const ADD_TOOL_MESSAGE = 'ADD_TOOL_MESSAGE';
export const CLEAN_MESSAGES = 'CLEAN_MESSAGES';
